<ng-container *ngIf="!isGridsterInMobileMode" [ngTemplateOutlet]="standardView"></ng-container>
<ng-container *ngIf="isGridsterInMobileMode" [ngTemplateOutlet]="miniModeView"></ng-container>

<ng-template #miniModeView>
    <toro-dashboard-widget-container
            [title]="title | translate"
            [titleIcon]="titleIcon"
            [showTitleIcon]="true"
            [showLinkButton]="true"
            [isBusy]="isBusy"
            [lastUpdated]="lastUpdated"
            [associatedWidget]="associatedWidget"
            [widgetMenuItems]="widgetMenuItems"
            [menuStyleClass]="'toro-widget-menu spec-context-menu'"
            [analyticsWidgetName]="analyticsWidgetName"
            [(alertText)]="alertText"
            [(isUnableToFetchData)]="isUnableToFetchData"
            [unableToFetchDataReason]="unableToFetchDataReason"
            [isMiniModeWidget]="true"
            (gotoSite)="onLinkClick()"
    >
        <div class="toro-flex-child mini-mode-widget-container toro-component-shield-host">
            <img *ngIf="isDemoMode" id="i3-demo-img" src="../../../../../../assets/images/intelli360/intelli360-maint-mini.png" class="prevent-select" alt="">

            <div *ngIf="!isDemoMode" class="toro-mini-mode-content-panel">
                <div id="tmm-mt-course-info" class="toro-mini-mode-content">
                    <div class="i3-ico-cnt-container">
                        <div><img src="../../../../../../assets/images/intelli360/i3-maintenance.png" alt=""></div>
                        <div class="i3-count-label">{{ 'CASE_SENSITIVE.TOTAL_MAINTENANCE_TASKS_DUE' | translate }}</div>
                    </div>
                </div>
            </div>
            <div class="toro-mini-mode-content-panel right">
                <div id="tmm-mt-metric-container" class="toro-mini-mode-content count">
                    <div>{{assets?.maintenanceDueAssetListModel?.length || '0'}}</div>
                </div>
            </div>
            <toro-component-shield (shieldClick)="onLaunchModalWidget()"></toro-component-shield>
        </div>

    </toro-dashboard-widget-container>
</ng-template>

<ng-template #standardView>
    <toro-dashboard-widget-container
            [title]="title | translate"
            [titleIcon]="titleIcon"
            [showTitleIcon]="true"
            [showLinkButton]="true"
            [isBusy]="isBusy"
            [lastUpdated]="lastUpdated"
            [associatedWidget]="associatedWidget"
            [widgetMenuItems]="widgetMenuItems"
            [menuStyleClass]="'toro-widget-menu spec-context-menu'"
            [analyticsWidgetName]="analyticsWidgetName"
            [(alertText)]="alertText"
            [(isUnableToFetchData)]="isUnableToFetchData"
            [unableToFetchDataReason]="unableToFetchDataReason"
            (gotoSite)="onLinkClick()"
    >
        <div class="toro-flex-child" id="spec-widget-content" (click)="showDesktopModal = true" style="cursor: pointer;">
            <div *ngIf="displayCols == 1 && displayRows == 1" class="toro-widget-content-pane c1-r1" [ngClass]="{'fade-on-resize': isResizing && !isBusy, 'is-demo': isDemoMode}">
                <img *ngIf="isDemoMode" src="../../../../../../assets/images/intelli360/intelli360-maint-1x1.png" class="prevent-select" alt="">

                <div *ngIf="!isDemoMode" class="i3-content-container d-flex fd-col c-c prevent-select">
                    <ng-container [ngTemplateOutlet]="oneByOneCount"></ng-container>
                </div>
            </div>

            <div *ngIf="displayCols == 2 && displayRows == 1" class="toro-widget-content-pane c2-r1" [ngClass]="{'fade-on-resize': isResizing && !isBusy, 'is-demo': isDemoMode}">
                <img *ngIf="isDemoMode" src="../../../../../../assets/images/intelli360/intelli360-maint-2x1.png" class="prevent-select" alt="">

                <ng-container [ngTemplateOutlet]="twoByOneContent"></ng-container>
            </div>

            <div *ngIf="displayCols == 1 && displayRows == 2" class="toro-widget-content-pane c1-r2" [ngClass]="{'fade-on-resize': isResizing && !isBusy}">
                <img src="../../../../../../assets/images/intelli360/intelli360-maint-1x2.png" class="prevent-select" alt="">
            </div>
        </div>
    </toro-dashboard-widget-container>
</ng-template>

<ng-template #titleIcon>
    <img *ngIf="isDemoMode" id="i360-title-icon" src="../../../../../../assets/images/intelli360/intelli360-md-logo.png" alt="">
</ng-template>

<ng-template #oneByOneCount>
    <div class="i3-ico-count"><img src="../../../../../../assets/images/intelli360/i3-maintenance.png" alt=""><span class="i3-count">{{ assets?.maintenanceDueAssetListModel?.length || 0 }}</span></div>
    <div class="i3-count-label">{{ 'CASE_SENSITIVE.TOTAL_MAINTENANCE_TASKS_DUE' | translate }}</div>
</ng-template>

<ng-template #twoByOneContent>
    <div *ngIf="!isDemoMode" class="i3-content-container d-flex">
        <div class="i3-flex-container">
            <div class="i3-ico-cnt-container prevent-select">
                <div class="i3-ico-cnt"><img src="../../../../../../assets/images/intelli360/i3-maintenance.png" alt=""><span class="i3-count">{{ assets?.maintenanceDueAssetListModel?.length || 0 }}</span></div>
                <div class="i3-count-label">{{ 'CASE_SENSITIVE.TOTAL_MAINTENANCE_TASKS_DUE' | translate }}</div>
            </div>
            <toro-i3-table
                    [assets]="maintenanceDueAssets"
                    [(selectedAsset)]="selectedAsset"
            ></toro-i3-table>
        </div>
        <div class="i3-flex-container notes">
            <div class="prevent-select" id="i3-col2-header"  [ngStyle]="{'padding-right': verticalScrollbarWidth + 'px'}">
                <div class="i3-c2-header asset">{{ (selectedAsset?.assetId ?? '') + ' ' +  ('STRINGS.TASKS' | translate) }}</div>
                <div class="i3-c2-header parts">{{'CASE_SENSITIVE.PARTS_NEEDED' | translate}}</div>
                <div class="i3-c2-header due">{{ 'STRINGS.DUE' | translate }}</div>
            </div>
            <div id="i3-details-container">
                <div #detailTableContainer  id="i3-notes-wrapper" *ngIf="selectedAsset != null">
                    <div *ngFor="let task of selectedAsset.tasks">
                        <toro-i3-maint-task-card [task]="task"></toro-i3-maint-task-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<toro-mini-mode-widget-modal *ngIf="showMiniModeModal" (cancel)="showMiniModeModal = false">
    <div id="mini-mode-modal-content-container">
        <ng-container [ngTemplateOutlet]="twoByOneContent"></ng-container>
    </div>
</toro-mini-mode-widget-modal>

<!--<toro-intelli360-modal-->
<!--        *ngIf="showDesktopModal"-->
<!--        [isMiniModal]="isGridsterInMobileMode"-->
<!--        [headerImgSrc]="'../../../../../../assets/images/intelli360/intelli360-md-logo.png'"-->
<!--        (gotoSite)="onLinkClick()"-->
<!--        (cancel)="showDesktopModal = false;"-->
<!--&gt;-->
<!--    <div id="i360-modal-content-container" [ngClass]="{'mini-modal': isGridsterInMobileMode}">-->
<!--        <img src="../../../../../../assets/images/intelli360/intelli360-maint-dt-modal.png" class="prevent-select" alt="">-->
<!--    </div>-->
<!--</toro-intelli360-modal>-->

